import axios from 'axios';
import config from '../config';
import securityService from './SecurityService';
export const SESSION_AUTH_TOKEN = 'authToken';

export class AuthService {

  lineLoginSSO: any;

  constructor() {
  }

  public getLineLoginSSO() {
    return this.lineLoginSSO;
  }

  public authRequest() {
    window.location.href = `/api/auth/cms/login`;
  }

  public inviteAuthRequest(token: string) {
    window.location.href = `/api/auth/cms/invite?token=${token}`;
  }

  public async getAuthToken(): Promise<string> {
    const response = await axios.get(`/api/auth/cms/token`);
    securityService.setAuthToken(response.data.token);
    return response.data.token;
  }

  public async logout(): Promise<any> {
    securityService.removeAuthToken();
    return await axios.get(`/api/auth/cms/logout`);
  }

}

const authService = new AuthService();
export default authService;
